module.exports = __webpack_public_path__ + "static/media/react-js-logo-cropped.015cff0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/react-js-logo-cropped.png
// module id = 60
// module chunks = 0